module.exports = __webpack_public_path__ + "static/media/toggle-right.2aca067e.svg";